import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as assessment from '../assessment'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: assessment.RESOURCE.payload.dimension.partialId,
      partialId: assessment.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Todo',
    isOptional: true,
    name: 'Case for Support',
    partialId: PartialId.Standard.create('case_for_support'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
